import { render, staticRenderFns } from "./CustomerViewMessageList.vue?vue&type=template&id=5bc35640&scoped=true&lang=pug&"
import script from "./CustomerViewMessageList.vue?vue&type=script&lang=js&"
export * from "./CustomerViewMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc35640",
  null
  
)

export default component.exports